import queryString from 'query-string';
import { CLEAN_AUTH } from '@/store/modules/auth';
import store from '@/store';
import router from '@/router';

export const backendUrlBase = process.env.VUE_APP_API_URL_BASE;
export const apiUrlBase = `${backendUrlBase}/api/v1`;

export const baseHeaders = () => ({
  Authorization: `Bearer ${store.state.auth.token}`,
  Accept: 'application/json',
  // Origin: window.location.origin,
  // 'Content-Type': 'application/json',
});

export const baseRequest = async (url, params = {}) => {
  try {
    const { headers = {}, ...p } = params;
    const data = await fetch(url, {
      // mode: 'cors',
      // credentials: 'include',
      headers: {
        ...baseHeaders(),
        ...headers,
      },
      ...p,
    });

    // Upsss!, the user is unauthenticated, then clean the user data
    // in Vuex and redirect to login route
    if (data.status === 401) {
      store.commit(`auth/${CLEAN_AUTH}`);

      router.push({ name: 'login' });
    }

    const parsed = await data.json();

    if (!data.ok) {
      const withStatus = { ...parsed, status: data.status };
      return Promise.reject(withStatus);
    }

    return Promise.resolve(parsed);
  } catch (error) {
    return Promise.reject(error);
  }
};

const customizedRequest = (method, endpoint, data = undefined, params = {}, encodeBody = true) => {
  const { headers = {}, ...p } = params;
  return baseRequest(`${apiUrlBase}/${endpoint}`, {
    method,
    ...(data !== undefined ? { body: encodeBody ? JSON.stringify(data) : data } : {}),
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      ...headers,
    },
    ...p,
  });
};

export const apiRequest = {
  get(endpoint, params) {
    return baseRequest(`${apiUrlBase}/${endpoint}`, params);
  },

  post(endpoint, data, params, encodeBody) {
    return customizedRequest('POST', endpoint, data, params, encodeBody);
  },

  put(endpoint, data, params) {
    return customizedRequest('PUT', endpoint, data, params);
  },

  patch(endpoint, data, params) {
    return customizedRequest('PATCH', endpoint, data, params);
  },

  delete(endpoint, params) {
    return customizedRequest('DELETE', endpoint, undefined, params);
  },
};

export const createAPIModule = ({ endpoint, getAllParams = () => ({}) }) => ({
  create: data => apiRequest.post(`${endpoint}`, data),

  delete: id => apiRequest.delete(`${endpoint}/${id}`),

  get: id => apiRequest.get(`${endpoint}/${id}`),

  getAll(params = {}) {
    const formattedParams = getAllParams(params);

    return apiRequest.get(`${endpoint}?${queryString.stringify(formattedParams)}`);
  },
  exportAll(params = {}) {
    const formattedParams = getAllParams(params);

    return apiRequest.get(`${endpoint}/export?${queryString.stringify(formattedParams)}`);
  },

  preCreate: () => apiRequest.get(`${endpoint}/create`),

  update: ({ id, data }) => apiRequest.patch(`${endpoint}/${id}`, data),
});

export { queryString };
